<template>
  <div class="questions-section-wrapper row">
    <div class="col-12">
      <h2 class="text-center pt-xxl pb-xl">
        Questions?<br>We have answers
      </h2>
    </div>
    <div class="offset-1 offset-xl-2 col-10 col-xl-8">
      <hr class="border-top-armor">
      <accordion-boxes
        :boxes="faqs"/>
    </div>
    <div class="d-flex gap-xs align-items-center justify-content-center my-xxl">
      <p>More questions?</p>
      <text-link
        class="full-faq"
        type="a"
        label="Check out the full FAQ"
        target="_self"
        href="/frequently-asked-questions">
        Check out the full FAQ
      </text-link>
    </div>
  </div>
</template>
<script setup>
import AccordionBoxes from './AccordionBoxes.vue'
import TextLink from '@/components/global/sequin/TextLink.vue'

const faqs = [
  {
    header: 'How does this work?',
    text: 'Armoire is a clothing rental service that gives ' +
          'members access to endless styles for a monthly fee. ' +
          'Shipping and cleaning are always free.'
  },
  {
    header: 'How many items come in my case?',
    text: 'Our current plans allow you to choose 4, 6, or 7 items per case. You\'re also able to upgrade ' +
          'to larger cases at any point.'
  },
  {
    header: 'How many cases do I get each month?',
    text: 'It\'s up to you! With our unlimited plan, you\'re welcome to exchange items every week if you like. Capsule plan members are eligible for a new case every 30 days. Unused exchanges always roll over to the next month on our Capsule plan.'
  },
  {
    header: 'How much does it cost to be a member?',
    text: `Capsule memberships range from ${window.armoire.plans.capsule.basePrice}-${window.armoire.plans['capsule-7'].basePrice} a month, and Unlimited memberships are ${window.armoire.plans.unlimited.basePrice} a month. We offer discounted trial pricing for new members on all of our plans.`
  },
  {
    header: 'How are my items chosen?',
    text: 'You pick what ships. We curate a selection for you with a combination ' +
          'of machine learning and input from our professional stylists — but you always ' +
          'choose what you get. '
  },
  {
    header: 'What if I need a break or want to change my plan?',
    text: 'There is no commitment with Armoire. You can change, pause or cancel ' +
          'your membership at any time. '
  }
]
</script>
<style lang="scss" scoped>
.questions-section-wrapper {
  max-width: 1440px;
  margin: 0 auto;
}
</style>